import { IPairUserRoleFile } from '../interfaces/pairUserRoleFile';
import { PataviumRole } from '../enums/role.enum.model';

export class PairUserRoleFile implements IPairUserRoleFile {
    idUser: number;
    idRole: PataviumRole;
    idFile: number;
    // usersNavigation: IUser;
    // filesNavigation: IStorageFile;

    constructor(urf?: IPairUserRoleFile) {
        if (urf) {
            this.idUser = urf.idUser;
            this.idRole = urf.idRole;
            this.idFile = urf.idFile;
            // this.usersNavigation = new User(urf.usersNavigation);
            // this.filesNavigation = new StorageFile(urf.filesNavigation);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/models/request-and-responses/rest-api/classes/pairUserRoleFile.ts